import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import authReducer from './auth';
import dashboadReducer from './dashboard';
import pipeReducer from './pipes';
import stakeholderReducer from './stakeholders';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import createFilter from 'redux-persist-transform-filter';

import storage from 'redux-persist/lib/storage';

import {
  persistReducer,
  persistStore,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';

const saveAuthReducer = createFilter('auth', [
  'token',
  'userId',
  'userName',
  'userCountry',
  'userEmail',
  'isLoggedIn',
]);

const persistConfig = {
  key: 'root',
  storage: storage,
  whitelist: ['auth'],
  transforms: [saveAuthReducer],
  stateReconciler: autoMergeLevel2,
};

const rootReducer = combineReducers({
  auth: authReducer,
  dashboard: dashboadReducer,
  pipe: pipeReducer,
  stakeholder: stakeholderReducer,
});

const persistedReducer = persistReducer<RootState>(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export type RootState = ReturnType<typeof rootReducer>;

export type AppDispatch = typeof store.dispatch;

export const persistor = persistStore(store);
